// utils/theme.js
export function applyTheme(isDark) {
    const root = document.documentElement;
    if (isDark) {
        root.style.setProperty('--header-bg', '#120E30');
        root.style.setProperty('--nav-text', '#EFF1FB');
        root.style.setProperty('--nav-active', '#ffffff');
        root.style.setProperty('--dropdown-bg', '#1c1742');
        root.style.setProperty('--dropdown-hover', '#2b245c');
        root.style.setProperty('--body-bg', '#120E30');
        root.style.setProperty('--top-bg', '#0A0C1E');
        root.style.setProperty('--nav1-text', '#EFF1FB');
        root.style.setProperty('--two-bg', '#0A0C1E');
        root.style.setProperty('--card-shadow', 'none');
        root.style.setProperty('--card-border', 'none');
        root.style.setProperty('--item-border', 'none');
    } else {
        root.style.setProperty('--header-bg', '#ffffff');
        root.style.setProperty('--nav-text', '#222');
        root.style.setProperty('--nav-active', '#953de8');
        root.style.setProperty('--dropdown-bg', '#ffffff');
        root.style.setProperty('--dropdown-hover', '#f0f0f0');
        root.style.setProperty('--body-bg', '#f7f8fc');
        root.style.setProperty('--top-bg', '#fff');
        root.style.setProperty('--two-bg', '#FBF8FF');
        root.style.setProperty('--nav1-text', 'rgba(102, 102, 102, 0.72)');
        root.style.setProperty('--card-shadow', '0px 26px 52px 0px #D2C9EB');
        root.style.setProperty('--card-border', '1px solid #D8CBFF');
        root.style.setProperty('--item-border', '0px 18px 48px 0px #E5DEF9');
    }
}

export function initGlobalTheme() {
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    const isDark = mql.matches;
    const followSystem = true;
    mql.addEventListener('change', (e) => {
        applyTheme(e.matches);
        window.dispatchEvent(new CustomEvent('theme-updated', { detail: e.matches }));
    });
    applyTheme(isDark);
    return { isDark, followSystem };
}

export function generateHalo() {
    const colorA = 'rgba(234, 216, 255, 0.42)';
    const colorB = 'rgba(210, 228, 255, 0.46)';
    const colorC = 'rgba(255, 228, 244, 0.34)';
    const rand = (min, max) => Math.random() * (max - min) + min;
    const CORNER_ZONES = [
        { name: 'TL', xRange: [2, 16], yRange: [2, 18] },
        { name: 'TR', xRange: [84, 98], yRange: [2, 18] },
        { name: 'BR', xRange: [84, 98], yRange: [82, 98] },
        { name: 'BL', xRange: [2, 16], yRange: [82, 98] }
    ];
    const pick = (zone) => ({
        x: Math.round(rand(zone.xRange[0], zone.xRange[1])),
        y: Math.round(rand(zone.yRange[0], zone.yRange[1]))
    });
    const dist = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);
    const MIN_DIST = 42;
    let positions = [];
    for (let attempt = 0; attempt < 18; attempt++) {
        const zoneIndexes = CORNER_ZONES.map((_, index) => index).sort(() => Math.random() - 0.5);
        const selected = zoneIndexes.slice(0, 3);
        const nextPositions = selected.map((index) => pick(CORNER_ZONES[index]));
        const isValid = nextPositions.every((point, index) =>
            nextPositions.slice(index + 1).every((other) => dist(point, other) >= MIN_DIST)
        );
        if (isValid) {
            positions = nextPositions;
            break;
        }
    }
    if (positions.length !== 3) {
        positions = [pick(CORNER_ZONES[0]), pick(CORNER_ZONES[1]), pick(CORNER_ZONES[2])];
    }
    const [pos1, pos2, pos3] = positions;
    const css = [
        `radial-gradient(108% 58% at ${pos1.x}% ${pos1.y}%, ${colorA} 0%, rgba(255,255,255,0) 42%)`,
        `radial-gradient(96% 52% at ${pos2.x}% ${pos2.y}%, ${colorB} 0%, rgba(255,255,255,0) 44%)`,
        `radial-gradient(88% 48% at ${pos3.x}% ${pos3.y}%, ${colorC} 0%, rgba(255,255,255,0) 40%)`
    ].join(', ');
    return {
        pos1,
        pos2,
        pos3,
        colorA,
        colorB,
        colorC,
        distance: Math.round(dist(pos1, pos2)),
        css
    };
}
